import { readApiJson } from './apiResponse';

export async function startSubscriptionCheckout({
  request,
  planId,
  billingCycle = 'monthly',
  source = 'upgrade',
  beforeRedirect,
}) {
  if (!planId) {
    throw new Error('Plan no seleccionado');
  }

  const response = await request('/api/payments/subscribe', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ planId, billingCycle, source }),
  });

  const data = await readApiJson(response);

  if (!response.ok) {
    throw new Error(data.message || 'No pudimos iniciar el pago con Mercado Pago');
  }

  if (data.initPoint) {
    if (typeof beforeRedirect === 'function') {
      beforeRedirect(data);
    }
    window.location.assign(data.initPoint);
    return data;
  }

  throw new Error('Mercado Pago no devolvió la URL de checkout');
}

export async function startOcrCheckout({ request, packId }) {
  if (!packId) {
    throw new Error('Pack no seleccionado');
  }

  const response = await request('/api/payments/ocr/checkout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ packId }),
  });

  const data = await readApiJson(response);

  if (!response.ok) {
    throw new Error(data.message || 'No pudimos iniciar el pago de escaneos');
  }

  if (data.initPoint) {
    window.location.href = data.initPoint;
    return data;
  }

  throw new Error('Mercado Pago no devolvió la URL de checkout');
}

export async function startOverageCheckout({ request, packId }) {
  if (!packId) {
    throw new Error('Pack no seleccionado');
  }

  const response = await request('/api/payments/overage/checkout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ packId }),
  });

  const data = await readApiJson(response);

  if (!response.ok) {
    throw new Error(data.message || 'No pudimos iniciar el pago de documentos extra');
  }

  if (data.initPoint) {
    window.location.href = data.initPoint;
    return data;
  }

  throw new Error('Mercado Pago no devolvió la URL de checkout');
}
